import { getPermissions } from '@app/api/account';
import { setAuthorizationToken } from '@app/api/api';
import { Configuration, PublicClientApplication, RedirectRequest } from '@azure/msal-browser';
import notification from '@digital/ui/lib/helpers/notification';
import { useActions } from '@digital/ui/lib/store';

const msalConfig: Configuration = {
  auth: {
    clientId: '5f8db391-565c-4a65-8719-7829453ffe4b',
    authority: 'https://login.microsoftonline.com/f47270a0-d3c7-4087-9a4c-b4d829d0b243',
    redirectUri: window.location.origin + '/auth/redirect',
    knownAuthorities: ['login.microsoftonline.com'],
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

export const loginRequest: RedirectRequest = {
  scopes: ['api://f67c02dc-7e1f-4472-b084-9456524a4f40/access_as_user'],
};

export const msalInstance = new PublicClientApplication(msalConfig);

export async function initMsal(loadPermissions: (perms: any[]) => void,onAuthenticate: (isAuthenticated: boolean) => void) {
  try {
    await msalInstance.initialize();
    const response: any = await msalInstance.handleRedirectPromise();

    if (!response) return;
    if (response && !response.account) return;
    console.log('[SSO] Login concluído', response.account.username);

    msalInstance.setActiveAccount(response.account);

    const scopes = ['api://f67c02dc-7e1f-4472-b084-9456524a4f40/access_as_user'];

    const tokenResponse = await msalInstance.acquireTokenSilent({
      account: response.account,
      scopes,
    });

    const accessToken = tokenResponse.accessToken;
    localStorage.setItem('isAuthenticated', 'true');
    localStorage.setItem('idtoken', accessToken);
    localStorage.setItem('expiration', String(Math.floor(tokenResponse.expiresOn!.getTime() / 1000)));
    localStorage.setItem('userName', response.account.username);


    setAuthorizationToken(accessToken);

    onAuthenticate(true);
    console.log('[SSO] Chamando getPermissions (merge do token local)...');
    const result: any = await getPermissions();

    if (!result) return;

    if (result.token) {
      localStorage.setItem('idtoken', result.token);
      setAuthorizationToken(result.token);
      localStorage.setItem('codigoUsuario', result.codigoUsuario);
      localStorage.setItem('isMRN', result.isMRN);
    }

    if (!result.permissions.length) {
      notification.error('Você não possui acesso ao sistema.');
      localStorage.removeItem('isAuthenticated');
      localStorage.removeItem('idtoken');
      localStorage.removeItem('expiration');
      localStorage.removeItem('userName');
      localStorage.removeItem('codigoUsuario');
      localStorage.removeItem('isMRN');
      loadPermissions([]);
      return;
    }

    //console.log('[SSO] Permissões carregadas:', result.permissions);
    loadPermissions(result.permissions);
    window.location.href = '/caixaDeEntrada';
  } catch (e) {
    console.error('[SSO] erro MSAL', e);
  } finally {
  }
}
